<template>
	<div class="chat-msg-item " :class="active ? 'active' : ''">
		<div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT">
			{{ msgInfo.content }}
		</div>
		<div class="chat-msg-tip"
			v-if="msgInfo.type == $enums.MESSAGE_TYPE.RECALL || msgInfo.type == $enums.MESSAGE_TYPE.NO_RECALL">
			{{ msgInfo.content }} <span v-if="msgInfo.type == $enums.MESSAGE_TYPE.RECALL"
				style="color: #2830d3;cursor: pointer;" @click="onNewEdit">{{ '再編集' }}</span>
		</div>
		<div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toTimeText(msgInfo.sendTime) }}
		</div>
		<div class="chat-msg-normal " v-if="isNormal" :class="{ 'chat-msg-mine': mine }">
			<div class="head-image">
				<head-image :name="showName" :size="38" :url="headImage" :id="msgInfo.sendId"></head-image>
			</div>
			<div class="chat-msg-content">
				<div v-show="mode == 1 && msgInfo.groupId && !msgInfo.selfSend" class="chat-msg-top">
					<span>{{ showName }}</span>
				</div>
				<div v-show="mode == 2" class="chat-msg-top">
					<span>{{ showName }}</span>
					<span>{{ $date.toTimeText(msgInfo.sendTime) }}</span>
				</div>
				<div class="chat-msg-bottom" @contextmenu.prevent="showMessageMenu($event)">
					<div ref="chatMsgBox">
						<div v-if="msgInfo.type == $enums.MESSAGE_TYPE.TEXT">
							<div class="chat-msg-text" v-html="htmlText"></div>
							<div class="translatedText"
								v-if="translateMap[msgInfo.id]?.show && translateMap[msgInfo.id]?.text">
								{{ translateMap[msgInfo.id].text }}
							</div>
							<div class="translatedText" v-if="translateMap[msgInfo.id]?.show && translationLoading">
								翻訳中...
							</div>
						</div>
						<div class="chat-msg-image" v-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE">
							<div v-loading="loading" element-loading-text="アップロード中です.."
								element-loading-background="rgba(0, 0, 0, 0.4)">
								<el-image ref="imageEl" :src="JSON.parse(msgInfo.content).thumbUrl" :fit="'contain'"
									style="width: 200px; height: 200px;" :preview-src-list="[imageUrl]"
									@click="showFullImageBox()" :preview-teleported="false" :initial-index="0">
								</el-image>
							</div>
							<span title="送信に失敗しました" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
						<div class="chat-msg-video" v-if="msgInfo.type == $enums.MESSAGE_TYPE.VIDEO">
							<video ref="videoPlayer" class="send-video" controls preload="none"
								:poster="JSON.parse(msgInfo.content).coverUrl"
								:src="JSON.parse(msgInfo.content).videoUrl" />
							<span title="送信に失敗しました" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
						<div class="chat-msg-file" v-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="loading">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" target="_blank" type="primary"
										:href="data.url" :download="data.name.endsWith('.pdf') ? null : data.name">
										{{ data.name }}
									</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
							<span title="送信に失敗しました" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
						<div class="chat-msg-file" v-if="msgInfo.type == $enums.MESSAGE_TYPE.PDF">
							<div class="chat-file-box" v-loading="loading">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" target="_blank" type="primary"
										:href="data.url">{{ data.name }}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
							<span title="送信に失敗しました" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
						<div v-if="msgInfo.type == $enums.MESSAGE_TYPE.ORDER" class="chat-msg-file"
							@click="openInfo(data)">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>{{ data.zhuwen }}</span>
								</div>
								<div class="item">納期：{{ data.deliveryDate }}</div>
								<div class="item">数量：{{ data.quantity }}</div>
								<div class="item">金額：{{ Number(data.amount).toFixed(0) }}</div>
								<div class="text item" @click.stop="viewPdf(data)">図面：{{ data.pdfName }}</div>
							</el-card>
							<span title="送信に失敗しました" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
					</div>
					<div class="chat-msg-voice" v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO" @click="onPlayVoice()">
						<audio controls :src="JSON.parse(msgInfo.content).url"></audio>
					</div>
					<div class="chat-action chat-msg-text" v-if="isAction">
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="再びっくりして呼び出す"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="再びっくりして呼び出す"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ msgInfo.content }}</span>
					</div>
					<div class="quote-message" v-if="msgInfo.quoteMessage"
						@contextmenu.prevent.stop="showQuoteMenu($event)">
						<chat-quote-message :msgInfo="msgInfo.quoteMessage"
							@click.native.stop="$emit('locateQuote', msgInfo)"
							:showName="quoteShowName"></chat-quote-message>
					</div>
					<div class="chat-msg-status" v-if="!isAction">
						<span class="chat-readed" v-show="msgInfo.selfSend && !msgInfo.groupId
							&& msgInfo.status == $enums.MESSAGE_STATUS.READED">既読しました</span>
						<span class="chat-unread" v-show="msgInfo.selfSend && !msgInfo.groupId
							&& msgInfo.status != $enums.MESSAGE_STATUS.READED">未読です</span>
					</div>
					<div class="chat-receipt" v-show="msgInfo.receipt" @click="onShowReadedBox">
						<span v-if="msgInfo.receiptOk" class="icon iconfont icon-ok" title="全員が既読しました"></span>
						<span v-else>{{ msgInfo.readedCount }}人が既読しました</span>
					</div>
				</div>
			</div>
		</div>
		<right-menu v-show="menu && rightMenu.show" :pos="rightMenu.pos" :items="menuItems"
			@close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
		<chat-group-readed ref="chatGroupReadedBox" :msgInfo="msgInfo" :groupMembers="groupMembers"></chat-group-readed>
		<OrderInfo :centerDialogVisible="visible" @resetPopupData="cancelDialog" :orderInfo="orderInfo" />
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
import OrderInfo from "./OrderInfo.vue";
import imageCache from "../../utils/imageCache.js";

export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded,
		ChatQuoteMessage,
		OrderInfo
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		active: {
			type: Boolean,
			default: false
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		quoteShowName: {
			type: String,
			default: ''
		},
		msgInfo: {
			type: Object,
			required: true
		},
		groupMembers: {
			type: Array
		},
		menu: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			audioPlayState: 'STOP',
			menuItems: [],
			rightMenu: {
				show: false,
				pos: {
					x: 0,
					y: 0
				}
			},
			visible: false,
			orderInfo: {},
			imageUrl: '',
			translationLoading: false,
			translateMap: {} // { [msgId]: { show: false, text: '' } }
		}
	},
	methods: {
		onSendFail() {
			this.$message.error("このファイルの送信には失敗しました。現在、自動的に再送信することはできません。手動で再送信することをおすすめします")
		},
		showFullImageBox() {
			let imageUrl = JSON.parse(this.msgInfo.content).originUrl;
			if (imageUrl) {
				this.imageUrl = imageUrl;
				// this.$store.commit('showFullImageBox', imageUrl);
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = JSON.parse(this.msgInfo.content).url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		showMenu(e) {
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = "true";
		},
		viewPdf(data) {
			window.open(data.previewUrl, "_blank");
		},
		// 打开订单详情
		openInfo(data) {
			this.orderInfo = data;
			this.visible = true;
		},
		cancelDialog() {
			this.visible = false;
		},
		// 显示翻译后的文本
		showTranslatedText(htmlText) {
			// 正则表达式匹配HTML标签
			const htmlRegex = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>|<!--[\s\S]*?-->/;
			return htmlRegex.test(htmlText);
		},
		showMessageMenu(e) {
			this.menuItems = [
				{ key: 'DELETE', name: '消す' }
			];
			if (this.msgInfo.type == 0) {
				const show = this.translateMap[this.msgInfo.id]?.show;
				this.menuItems.push({
					key: 'TRANSLATE',
					name: show ? '翻訳を取り消す' : '翻訳'
				});
			}
			if (this.msgInfo.selfSend && this.msgInfo.id > 0) {
				this.menuItems.push({ key: 'RECALL', name: '撤回する' });
			}
			if (this.$msgType.isNormal(this.msgInfo.type)) {
				this.menuItems.push({ key: 'QUOTE', name: '引用する' });
			}
			this.showMenu(e);
		},
		showQuoteMenu(e) {
			this.menuItems = [];
			if (this.msgInfo.quoteMessage &&
				this.msgInfo.quoteMessage.status != this.$enums.MESSAGE_STATUS.RECALL) {
				this.menuItems.push({
					key: 'LOCATE_QUOTE',
					name: '元のメッセージにジャンプする'
				});
			}
			this.showMenu(e);
		},
		onSelectMenu(item) {
			let eventKey = item.key.toLowerCase().replace(/_([a-z])/g, (g) => g[1].toUpperCase());
			this.$emit(eventKey, this.msgInfo);
			if (eventKey == 'translate') {
				const msgId = this.msgInfo.id;
				if (!this.translateMap[msgId]?.show) {
					// 需要翻译
					this.translationLoading = true;
					this.$set(this.translateMap, msgId, { show: true, text: '' });
					try {
						// 这里调用翻译API
						// const res = await translateText(this.msgInfo.content);
						let data = {
							id: this.msgInfo.id,
							message: this.msgInfo.content,
						}
						if (this.msgInfo.groupId) {
							// 群聊翻译
							this.$http.post(`/sample/groupTranslate?id=${this.msgInfo.id}&message=${this.msgInfo.content}`, {}, {}).then((res) => {
								this.$set(this.translateMap[msgId], 'text', res);
								this.translationLoading = false;
							}).catch((res) => {
								this.translationLoading = false;
							})
						} else {
							// 私聊翻译
							this.$http.post(`/sample/privateTranslate?id=${this.msgInfo.id}&message=${this.msgInfo.content}`, {}, {}).then((res) => {
								this.$set(this.translateMap[msgId], 'text', res);
								this.translationLoading = false;
							}).catch((res) => {
								this.translationLoading = false;
							})
						}

					} catch (e) {
						this.$set(this.translateMap[msgId], 'text', '翻译失败');
						this.translationLoading = false;
					}
				} else {
					// 取消翻译
					this.$set(this.translateMap, msgId, { show: false, text: '' });
				}
			}
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		},
		// 重新编辑
		onNewEdit() {
			this.$emit('onNewEdit', this.msgInfo);
		},
	},
	mounted() {
		// // 预加载图片
		// if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.IMAGE) {
		// 	const imageUrl = this.imageSrc;
		// 	if (imageUrl) {
		// 		imageCache.preloadImage(imageUrl);
		// 	}
		// }

	},
	computed: {
		loading() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "loading";
		},
		loadFail() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "fail";
		},
		data() {
			return JSON.parse(this.msgInfo.content)
		},
		// imageSrc() {
		// 	// 优化图片加载，使用全局缓存策略
		// 	if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.IMAGE) {
		// 		const messageId = this.msgInfo.id || this.msgInfo.tmpId;
		// 		return imageCache.getImageUrl(this.msgInfo.content, messageId);
		// 	}
		// 	return '';
		// },
		fileSize() {
			let size = this.data.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		isAction() {
			return this.$msgType.isAction(this.msgInfo.type);
		},
		isNormal() {
			const type = this.msgInfo.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		htmlText() {
			let color = this.msgInfo.selfSend ? 'white' : '';
			let text = this.$url.replaceURLWithHTMLLinks(this.msgInfo.content, color)
			return this.$emo.transform(text)
		}
	}
}
</script>

<style lang="scss">
.active {
	background: #eee;
}

.chat-msg-item {
	padding: 2px 0;

	.chat-msg-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
	}



	.chat-msg-normal {
		position: relative;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin-top: 10px;

		// 新增全局翻译样式
		.translatedText {
			color: #000;
			font-size: 16px;
			background-color: #f1f1f1;
			padding: 6px 10px;
			border-radius: 8px;
			margin-top: 4px;
		}

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.chat-msg-content {
			text-align: left;

			.send-fail {
				color: #e60c0c;
				font-size: 30px;
				cursor: pointer;
				margin: 0 20px;
			}

			.chat-msg-top {
				display: flex;
				flex-wrap: nowrap;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;

				span {
					margin-right: 12px;
				}
			}

			.chat-msg-bottom {
				display: inline-block;
				padding-right: 300px;
				padding-left: 5px;

				.chat-msg-text {
					display: inline-flex;
					position: relative;
					line-height: 26px;
					padding: 6px 10px;
					background-color: var(--im-background);
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-all;

					&:after {
						content: "";
						position: absolute;
						left: -10px;
						top: 13px;
						width: 0;
						height: 0;
						border-style: solid dashed dashed;
						border-color: #eee transparent transparent;
						overflow: hidden;
						border-width: 10px;
					}
				}

				.chat-msg-image {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;

					.send-image {
						min-width: 200px;
						min-height: 150px;
						max-width: 400px;
						max-height: 300px;
						border-radius: 8px;
						cursor: pointer;
					}
				}


				.chat-msg-video {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;

					.send-video {
						min-width: 200px;
						max-width: 300px;
						max-height: 300px;
						border-radius: 10px;
						overflow: hidden;
						cursor: pointer;
						object-fit: contain;
					}
				}


				.chat-msg-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;

					.box-card {
						width: 300px;
						font-size: 14px;

						.el-card__header {
							padding: 10px;

							.clearfix {
								text-align: left;
							}
						}

						.el-card__body {
							padding: 10px;

							.item {
								margin-bottom: 8px;
								text-align: left;
							}

							.text {
								color: #2830d3;
							}
						}
					}

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 4px;
						padding: 10px 15px;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							font-size: 44px;
							color: #d42e07;
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

				.chat-msg-voice {
					font-size: 14px;
					cursor: pointer;

					audio {
						height: 45px;
						padding: 5px 0;
					}
				}

				.chat-action {
					display: flex;
					align-items: center;

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}

				.quote-message {
					display: block;
					margin-top: 3px;
					cursor: pointer;
				}

				.chat-msg-status {
					display: block;

					.chat-readed {
						font-size: 12px;
						color: var(--im-text-color-light);
					}

					.chat-unread {
						font-size: var(--im-font-size-smaller);
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: var(--im-font-size-smaller);
					cursor: pointer;
					color: var(--im-text-color-light);

					.icon-ok {
						font-size: 20px;
						color: var(--im-color-sucess);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}


		&.chat-msg-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 48px;

			.head-image {
				left: auto;
				right: 0;
			}

			.chat-msg-content {
				text-align: right;

				.chat-msg-top {
					flex-direction: row-reverse;

					span {
						margin-left: 12px;
						margin-right: 0;
					}
				}

				.chat-msg-bottom {
					padding-left: 180px;
					padding-right: 5px;

					.chat-msg-text {
						margin-left: 10px;
						background-color: var(--im-color-primary-light-2);
						color: #fff;

						&:after {
							left: auto;
							right: -10px;
							border-top-color: var(--im-color-primary-light-2);
						}
					}

					.translatedText {
						color: #000;
						font-size: 16px;
						background-color: #e0e0e0;
						padding: 6px 10px;
						border-radius: 8px;
						margin-top: 4px;
					}

					.chat-msg-image {
						flex-direction: row-reverse;
					}

					.chat-msg-video {
						flex-direction: row-reverse;
					}

					.chat-msg-file {
						flex-direction: row-reverse;
					}

					.chat-action {
						flex-direction: row-reverse;

						.iconfont {
							transform: rotateY(180deg);
						}
					}
				}
			}
		}

	}
}

.translate-btn {
	display: inline-block;
	margin: 4px 0 0 0;
	padding: 2px 10px;
	background: #f5f5f5;
	color: #2830d3;
	border-radius: 6px;
	font-size: 13px;
	cursor: pointer;
	user-select: none;
}
</style>